import React from 'react';

import SubmissionCalendar from './SubmissionCalendar';
import SubmissionHeatmap from './SubmissionHeatmap';
import { CardHeader } from './ui/Card';
import useSelectedResource from '../hooks/useSelectedResource';

export default function MonthlySubmissions({ year, month, horizon }) {
  const selectedResource = useSelectedResource();
  const resourceId = selectedResource?.id;

  return (
    <div className="w-full h-full flex flex-col">
      <CardHeader
        title="Submissions"
        description="Every session this month."
        className="mb-3"
      />
      <div className="flex-1">
        <div className="hidden lg:block">
          <SubmissionHeatmap
            resourceId={resourceId}
            year={year}
            month={month}
            selectedHorizon={horizon}
          />
        </div>
        <div className="lg:hidden">
          <SubmissionCalendar key={`${year}-${month}`} year={year} month={month} />
        </div>
      </div>
    </div>
  );
}
